import { EventRegistryCategory } from '../../EventRegistryCategory';
import { EventRegistryItem } from '../../EventRegistryItem';
export class EventRegistryReactFocus extends EventRegistryCategory {
    label = 'Focus Events';
    constructor(parent) {
        super(parent);
        super.init();
    }
    focus = () => new EventRegistryItem({ handlerName: 'onFocus' });
    blur = () => new EventRegistryItem({ handlerName: 'onBlur' });
}
